import { Trans, useLingui } from '@lingui/react/macro';

import { cn } from '@/lib/utils';

export interface ModuleUnavailableHintProps {
  /** `block` renders a paragraph under a field; `inline` renders in running text or a cell. */
  variant?: 'block' | 'inline';
  className?: string;
  /** Lets a disabled control point at the hint with `aria-describedby`. */
  id?: string;
}

/**
 * The shared hint for a picker or lookup whose data the role cannot read
 * (issue #1670). One msgid for every site.
 */
export function ModuleUnavailableHint({ variant = 'block', className, id }: ModuleUnavailableHintProps) {
  const Element = variant === 'inline' ? 'span' : 'p';
  return (
    <Element id={id} className={cn('text-xs text-muted-foreground', className)}>
      <Trans id="access.notAvailableForRole">Not available for your role</Trans>
    </Element>
  );
}

/** The translated hint text, for `description` props and plain-string cells. */
export function useNotAvailableForRoleLabel(): string {
  const { t } = useLingui();
  return t({ id: 'access.notAvailableForRole', message: 'Not available for your role' });
}
